import { Card, CardContent, Paper, Typography } from '@mui/material';
import ResponsiveAppBar from '../ResponsiveAppBar';
import { useGetUserInfoQuery } from '../services/api';
import { StyledHeaderBox } from '../StyledHeaderBox';
import { MemberProfile } from './MemberProfile';
import { PractitionerProfile } from './PractitionerProfile';

const Profile = () => {
  const { data: user } = useGetUserInfoQuery();
  if (!user)
    return null;

  return (
    <>
      <ResponsiveAppBar />
      <Paper
        style={{
          background: '#a0b1af',
          height: 'calc(100vh - 56px)',
          overflow: 'scroll',
          paddingBottom: 10,
          paddingTop: 10,
        }}
      >
        <StyledHeaderBox>
          <Typography
            sx={{
              marginLeft: { xs: 1 }
            }}
            variant="h6"
          >Settings</Typography>
        </StyledHeaderBox>
        <Card
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: 10,
          }}
        >
          <CardContent
            style={{
              flex: 1,
            }}
          >
            <MemberProfile />
            <PractitionerProfile />
          </CardContent>
        </Card>
      </Paper>
    </>
  )
}

export default Profile;
